import { $fetch } from '@block/utils';
import { SuccessFile } from '@src/types/self';
import { CertificateType } from '../../types';
import { REASON_TYPE_MAP } from './constants';
import Url from '../../url';

// 获取OCR识别的证书编码
export const fetchOcrCode = async (
  file: SuccessFile,
): Promise<{
  ocrCode?: string;
  ocrNum?: string;
  ocrMsg?: string;
}> => {
  try {
    const { fileId, fileName } = file || {};
    const ocrResult = await $fetch(Url.ocrEdu, {
      fileId,
      fileName,
    });
    return ocrResult;
  } catch (error) {
    return {
      ocrMsg: 'OCR识别失败',
    };
  }
};

// 获取无法上传原因列表
export const fetchReasonList = async (certificateType?: CertificateType): Promise<any[]> => {
  try {
    // 接口入参，如果没有传入证书类型，则返回所有原因列表
    const type = certificateType ? REASON_TYPE_MAP[certificateType] : undefined;

    const unableReason = await $fetch(Url.getUnableReason, {
      type,
    });

    return unableReason?.pageList || [];
  } catch (error) {
    console.error('获取原因列表失败', error);
    return [];
  }
};
